import { useState } from "react";
import { CopyIndicator } from "./CopyIndicator";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../components/ui/table";
import { TabsContent } from "../components/ui/tabs";
import { copyId, truncateIdFirstLast } from "../lib/utils";
import { NewPortfolioTrigger } from "./modals/NewPortfolioTrigger";
import { EditPortfolioTrigger } from "./modals/EditPortfolioTrigger";
import type { Portfolio } from "global-types";

interface PortfoliosProps {
  portfolios: Portfolio[];
  accountId: string | number;
  onPortfolioCreated?: () => void;
  onPortfolioUpdated?: () => void;
}

export const Portfolios = ({
  portfolios,
  accountId,
  onPortfolioCreated,
  onPortfolioUpdated,
}: PortfoliosProps) => {
  const [activeId, setActiveId] = useState<string | null>(null)

  return (
    <TabsContent value="portfolio" className="mt-4 w-min max-w-full mx-auto">
      <div className="mb-8 space-y-4">
        <NewPortfolioTrigger
          accountId={accountId}
          onPortfolioCreated={onPortfolioCreated}
        />
        {portfolios.length === 0 ? (
          <p>No portfolios found for this account.</p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead></TableHead>
                <TableHead>
                  <div className="inline-flex items-center gap-1">ID</div>
                </TableHead>
                <TableHead>Name</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow></TableRow>
              {portfolios.map(({ id, name }) => (
                <TableRow key={id}>
                  <TableCell>
                    <EditPortfolioTrigger
                      portfolioId={id}
                      accountId={accountId}
                      onPortfolioUpdated={onPortfolioUpdated}
                    />
                  </TableCell>
                  <TableCell>
                    <button
                      onClick={() => {
                        setActiveId(id)
                        copyId(id)
                      }}
                      className="hover:text-blue-600 transition-colors cursor-pointer inline-flex items-center gap-2"
                      title="Click to copy ID"
                    >
                      {truncateIdFirstLast(id)}
                      <CopyIndicator activeId={activeId} thisId={id} />
                    </button>
                  </TableCell>
                  <TableCell>{name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    </TabsContent>
  );
};
